import React from 'react'

const MountDetector = ({ onMounted, onWillUnmount }) => {
  React.useEffect(() => {
    if(onMounted){
      onMounted()
    }
    return () => {
      if(onWillUnmount){
        onWillUnmount()
      }
    }
  }, [])

  return null;
}

export default MountDetector
